import { LAYER_NAME_DRAG_TYPE, LAYER_SOURCE_DRAG_TYPE, type LayerSourceRef } from './CanvasLayers';

export interface ThumbnailItem {
  id: number | string;
  url: string;
  alt: string;
  // Url carried by the drag when it differs from the displayed thumbnail.
  dragUrl?: string;
}

interface CanvasThumbnailGridProps {
  items: ThumbnailItem[];
  // Library the items come from; the dropped image keeps it with the item id so the canvas saves the reference.
  kind: LayerSourceRef['kind'];
}

// Draggable thumbnails: the stage reads the dropped url and adds it as an image.
const CanvasThumbnailGrid = ({ items, kind }: CanvasThumbnailGridProps) => (
  <div className="grid grid-cols-2 gap-3">
    {items.map((item) => (
      <img
        key={item.id}
        src={item.url}
        alt={item.alt}
        draggable
        onDragStart={(e) => {
          const dragUrl = item.dragUrl ?? item.url;
          e.dataTransfer.setData('text/uri-list', dragUrl);
          e.dataTransfer.setData('text/plain', dragUrl);
          e.dataTransfer.setData(LAYER_NAME_DRAG_TYPE, item.alt);
          e.dataTransfer.setData(LAYER_SOURCE_DRAG_TYPE, JSON.stringify({ kind, id: item.id } satisfies LayerSourceRef));
          e.dataTransfer.effectAllowed = 'copy';
        }}
        className="w-full aspect-square object-cover rounded-lg border border-gray-200 cursor-grab"
      />
    ))}
  </div>
);

export default CanvasThumbnailGrid;
